import { Setup } from "../setup/Setup";

export function applog(...args: any[]) {
    if (Setup.getInstance().showLogs) {
        console.log(...args);
    }
}